import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { UiSortMenu } from '@/components';
import type { SortMenuItem } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'AuraProcessingCostsSort',
  props: {
    modelValue: { type: Array, required: true }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;
const emit = __emit;
const { t } = useI18n();

const items = ref<SortMenuItem[]>([
    { label: t('aura.processingCosts.sort.startedAt'), key: 'startedAt' },
    { label: t('aura.processingCosts.sort.costUsd'), key: 'costUsd' },
    { label: t('aura.processingCosts.sort.tokensUsed'), key: 'tokensUsed' },
]);

const __returned__ = { props, emit, t, items, get UiSortMenu() { return UiSortMenu } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})